//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BcIsoCertificate from '@/components/svg/bc-iso-certificate.vue';
import BcNenCertificate from '@/components/svg/bc-nen-certificate.vue';
import DutchLaravelFoundation from '@/components/svg/dutch-laravel-foundation.vue';
import LaravelCertificate from '@/components/svg/laravel-certificate.vue';
import PageHeader from '@/components/page/header.vue';

export default {
    components: {
        BcIsoCertificate,
        BcNenCertificate,
        DutchLaravelFoundation,
        LaravelCertificate,
        PageHeader,
    },
    scrollToTop: true,
    data() {
        return {
            debounce: null,
            images: [
                [
                    {
                        aspectRatio: 'aspect-w-4 aspect-h-3 lg:aspect-w-80 lg:aspect-h-67',
                        src: '/images/about/foto1.webp',
                    },
                    {
                        aspectRatio: 'aspect-w-4 aspect-h-3 lg:aspect-w-40 lg:aspect-h-57',
                        src: '/images/about/foto2.webp',
                    },
                ],
                [
                    {
                        aspectRatio: 'aspect-w-4 aspect-h-3 lg:aspect-w-400 lg:aspect-h-617',
                        src: '/images/about/foto3.webp',
                    },
                    {
                        aspectRatio: 'aspect-w-4 aspect-h-3 lg:aspect-w-25 lg:aspect-h-18',
                        src: '/images/about/foto4.webp',
                    },
                ],
                [
                    {
                        aspectRatio: 'aspect-w-4 aspect-h-3 lg:aspect-w-25 lg:aspect-h-29',
                        src: '/images/about/foto5.webp',
                    },
                    {
                        aspectRatio: 'aspect-w-4 aspect-h-3 lg:aspect-w-400 lg:aspect-h-441',
                        src: '/images/about/foto6.webp',
                    },
                ],
            ],
            partners: [
                'sonnema',
                'snap',
                'trivago',
                'tommy_hilfiger',
                'cbre',
                'exterion',
                'rdg',
                'fagron',
                'erasmusmc',
                'belmond',
                'ferring',
                'zha',
            ],
            services: [
                {
                    pre: '01',
                    title: this.$t('services.items.brainstorm.title'),
                    text: this.$t('services.items.brainstorm.description'),
                },
                {
                    pre: '02',
                    title: this.$t('services.items.design.title'),
                    text: this.$t('services.items.design.description'),
                },
                {
                    pre: '03',
                    title: this.$t('services.items.develop.title'),
                    text: this.$t('services.items.develop.description'),
                },
                {
                    pre: '04',
                    title: this.$t('services.items.manage.title'),
                    text: this.$t('services.items.manage.description'),
                },
            ],
        };
    },
    head() {
        return {
            meta: [
                {
                    hid: 'og:title',
                    name: 'og:title',
                    content: this.$t('page_title'),
                },
            ],
            title: this.$t('page_title'),
        };
    },
};
